<template>

<core-list-column :format="format" type="date" class="column">
	{{ format.title }}
</core-list-column>

</template>

<script>

export default {

	props: ['format']

}

</script>

<style scoped>

.column {
	width: 90px;
	flex-shrink: 0;
	text-align: center;
}

@media only screen and (max-width: 767px) {

	.column {
		width: 64px;
	}

}

</style>